/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Input, Modal, Progress, Row, Select, Table } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getReportNotificationsApi } from '../../../api/customerApi';
import AddDeviceNotification from '../../../assets/icons/add_service.svg';
import AdvertiseNotification from '../../../assets/icons/advertise.svg';
import AlertNotification from '../../../assets/icons/alert.svg';
import CarNotification from '../../../assets/icons/car_noti.svg';
import DisconnectedDeviceNotification from '../../../assets/icons/disconnect_device.svg';
import EventObjectDetectionNotification from '../../../assets/icons/event_detect.svg';
import CameraTampering from '../../../assets/icons/camera_tampered.svg';
import KnifeNotification from '../../../assets/icons/knife_noti.svg';
import MotobikeNotification from '../../../assets/icons/motobike_noti.svg';
import PeopleNotification from '../../../assets/icons/people_notif.svg';
import RemoveDeviceNotification from '../../../assets/icons/remove_device.svg';
import SungNotification from '../../../assets/icons/sung_noti.svg';
import UpdateSystemNotification from '../../../assets/icons/update_system.svg';
import * as SERVICE from '../../../constants/service.types';
import { NOTIFIES, DECODED_ACCESS_TOKEN } from '../../../constants/system.keys';
import * as ACTIONS from '../../../redux/actions';
import { socketEmitEvent } from '../../../redux/actions';
import storageService from '../../../services/storage.service';

const { Option } = Select;
const { RangePicker } = DatePicker;

const NotificationsTab = ({ namespace, localNamespace, isAuth, currentTab }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { filterNotifications, listAlert } = useSelector((state) => state);

  const [timeRequest] = useState(new Date().getTime());
  const [dataFilterType, setDataFilterType] = useState('disconnected_device');
  const [percent, setPercent] = useState(0);
  const [dataNotification, setDataNotifcation] = useState({
    data: [],
    pagination: {
      current: 2,
      pageSize: 10,
    },
    loading: false,
  });
  const [expKeys, setExpKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataDetail, setDataDetail] = useState();
  const [keyRanger, setKeyRanger] = useState(Math.random());
  const [isLoadingDownloadNotification, setIsLoadingDownloadNotification] =
    useState(false);
  const [notificationInputSearch, setNotificationInputSearch] = useState('');
  const [dateRanger, setDateRanger] = useState([
    moment(
      moment().subtract(1, 'days').set({ hour: 0, minute: 0, second: 0 }),
    ).valueOf(),
    moment().valueOf(),
  ]);

  useEffect(() => {
    if (filterNotifications) {
      setDataNotifcation((state) => ({
        ...state,
        loading: false,
        data:
          filterNotifications.notifications?.filter((item) =>
            item?.content
              ?.toLowerCase()
              .includes(notificationInputSearch.toLowerCase()),
          ) || [],
        pagination: {
          ...state.pagination,
          total: filterNotifications.total,
        },
      }));
    }
  }, [filterNotifications, notificationInputSearch]);

  useEffect(() => {
    if (
      isAuth === 1 &&
      namespace &&
      dateRanger?.length === 2 &&
      dataFilterType
    ) {
      setDataNotifcation((state) => ({
        ...state,
        data: state.data?.filter((item) =>
          item?.content
            ?.toLowerCase()
            .includes(notificationInputSearch.toLowerCase()),
        ),
        pagination: {
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
      let data = {
        namespace,
        page: 0,
        size: 10,
        timeRequest,
        fromTime: dateRanger[0],
        toTime: dateRanger[1],
        type: dataFilterType,
        input: notificationInputSearch,
      };
      let dataObj = {
        appServiceType: SERVICE.FILTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [
    dispatch,
    isAuth,
    namespace,
    timeRequest,
    dateRanger,
    dataFilterType,
    notificationInputSearch,
  ]);

  useEffect(() => {
    if (percent === 100) {
      setTimeout(() => {
        setPercent(0);
      }, 1000);
    }
  }, [percent]);

  const handleTableChangeNotification = useCallback(
    (pagination, _, sort) => {
      setDataNotifcation((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: pagination.pageSize,
          current: pagination.current,
        },
        loading: true,
      }));

      let data = {
        namespace,
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        fromTime: dateRanger[0],
        toTime: dateRanger[1],
        type: dataFilterType,
        input: notificationInputSearch,
      };
      let dataObj = {
        appServiceType: SERVICE.FILTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [
      dispatch,
      namespace,
      timeRequest,
      dateRanger,
      dataFilterType,
      notificationInputSearch,
    ],
  );

  const handleSearchNotification = useCallback(
    (value) => {
      setDataNotifcation((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: state.pagination.pageSize,
          current: 1,
        },
        loading: true,
      }));

      let data = {
        namespace,
        page: 0,
        size: dataNotification.pagination.pageSize,
        timeRequest,
        fromTime: dateRanger[0],
        toTime: dateRanger[1],
        type: dataFilterType,
        input: notificationInputSearch,
      };
      let dataObj = {
        appServiceType: SERVICE.FILTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [
      dispatch,
      namespace,
      timeRequest,
      dateRanger,
      dataFilterType,
      notificationInputSearch,
      dataNotification.pagination.pageSize,
    ],
  );

  const handleChangeSelect = (value) => {
    setDataFilterType(value);
  };

  const handleDownloadNotification = useCallback(async () => {
    try {
      setIsLoadingDownloadNotification(true);
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);

      const dataQuery = {
        namespace,
        customerNamespace: namespace,
        isDownload: 1,
        type: dataFilterType,
        input: notificationInputSearch || '',
        fromTime: moment(dateRanger[0]).startOf('day').valueOf(),
        toTime: moment(dateRanger[1]).endOf('day').valueOf(),
      };

      const dataRes = await getReportNotificationsApi(
        token,
        { namespace: localNamespace },
        dataQuery,
      );

      if (!dataRes?.data) {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        return;
      }

      const blob = new Blob([dataRes.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'report-members.xlsx';
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      ACTIONS.openMessage(
        NOTIFIES.WARNING,
        error?.response?.data?.message ?? 'Download failed',
      );
    } finally {
      setIsLoadingDownloadNotification(false);
    }
  }, [
    namespace,
    localNamespace,
    dataFilterType,
    notificationInputSearch,
    dateRanger,
  ]);

  const handleDateRangerChange = (values) => {
    if (values?.length === 2) {
      const FromDate =
        values.length > 0
          ? values[0].set({ hour: 0, minute: 0, second: 0 })
          : '';
      const ToDate =
        values.length > 0
          ? values[1].set({ hour: 23, minute: 59, second: 59 })
          : '';
      const dataArr = [FromDate, ToDate];
      setDateRanger(dataArr.map((item) => Math.floor(moment(item).valueOf())));
      setKeyRanger(Math.random());
    } else {
      setDateRanger([]);
    }
  };

  const handleChangeDisconnect = (item, value) => {
    let dataInfo = (item?.extraInfo && JSON.parse(item.extraInfo)) || {};
    dataInfo.errorCode = value;
    item.status = 3;
    let data = {
      notificationId: item.id,
      status: 3,
      namespace,
      extraInfo: JSON.stringify({ ...dataInfo }),
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_NOTIFICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    setTimeout(() => {
      setPercent(100);
    }, 400);
    dispatch(socketEmitEvent(dataObj));
  };

  const onChangeAlert = (extraInfo) => {
    if (namespace) {
      let dataBody = {
        namespace,
        deviceTypeId: (extraInfo && JSON.parse(extraInfo)?.deviceTypeId) || 3,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALERT,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  const handleCancelModalDetail = () => {
    setIsModalVisible(false);
    setDataDetail(undefined);
  };

  const extraInfoNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'alert':
        temple = <div></div>;
        break;
      case 'event_object_detection':
        temple = (
          <div>
            <a>
              <img
                src={
                  item.extraInfo &&
                  JSON.parse(item.extraInfo) &&
                  (JSON.parse(item.extraInfo).imageUrl ??
                    JSON.parse(item.extraInfo).url)
                }
                style={{
                  width: '400px',
                  marginTop: '0.5rem',
                  marginLeft: '0.5rem',
                }}
                onClick={() => {
                  dispatch(
                    ACTIONS.popupVideoStorageFileByTimeReturn({
                      dataDetail: item,
                      isModalVisible: true,
                    }),
                  );
                }}
              />
            </a>
          </div>
        );
        break;
      case 'update_system':
        temple = (
          <div style={{ margin: '0.25rem 0 0 0.5rem' }}>
            <span style={{ fontSize: '12px', color: '#797979' }}>
              {t('Related effects')}:
              {item.content &&
                JSON.parse(item.content) &&
                JSON.parse(item.content).effect}
            </span>
          </div>
        );
        break;
      case 'add_device':
        temple = <div></div>;
        break;
      case 'remove_device':
        temple = <div></div>;
        break;
      case 'disconnected_device':
        temple = (
          <Row style={{ padding: '8px 8px 0px 8px', display: 'block' }}>
            <Col span={6}>
              <Select
                size="small"
                placeholder={t('Select reason')}
                style={{ width: '100%' }}
                defaultValue={
                  (item?.extraInfo && JSON.parse(item.extraInfo)?.errorCode) ||
                  undefined
                }
                onChange={(value) => handleChangeDisconnect(item, value)}
              >
                {listAlert?.map((alertItem) => (
                  <Option key={alertItem.errorCode} value={alertItem.errorCode}>
                    {alertItem.title}
                  </Option>
                ))}
              </Select>
            </Col>
            {percent === 100 && (
              <Col span={6}>
                <Progress style={{ width: '100%' }} percent={percent} />
              </Col>
            )}
          </Row>
        );
        break;
      case 'advertise':
        temple = (
          <div>
            <span style={{ fontSize: '12px', color: '#797979' }}>
              {t('App description')}:
              {item.extraInfo &&
                JSON.parse(item.extraInfo) &&
                JSON.parse(item.extraInfo).summary}
            </span>
          </div>
        );
        break;
      default:
    }
    return temple;
  };

  const contentNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'event_object_detection':
        let array_object =
          item.extraInfo &&
          JSON.parse(item.extraInfo) &&
          JSON.parse(item.extraInfo).objects &&
          JSON.parse(item.extraInfo).objects.split(',');
        let key_object = {};
        array_object &&
          array_object.forEach((e) => {
            if (e == 'car') {
              key_object.car = true;
            }
            if (e == 'motor') {
              key_object.motor = true;
            }
            if (e == 'gun') {
              key_object.gun = true;
            }
            if (e == 'knife') {
              key_object.knife = true;
            }
            if (e == 'person') {
              key_object.person = true;
            }
          });
        temple = (
          <div>
            <span>{item.content}</span>
            {key_object.person ? (
              <img style={{ marginLeft: '10px' }} src={PeopleNotification} />
            ) : (
              ''
            )}
            {key_object.car ? (
              <img style={{ marginLeft: '5px' }} src={CarNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img style={{ marginLeft: '5px' }} src={KnifeNotification} />
            ) : (
              ''
            )}
            {key_object.motor ? (
              <img style={{ marginLeft: '5px' }} src={MotobikeNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img style={{ marginLeft: '5px' }} src={SungNotification} />
            ) : (
              ''
            )}
          </div>
        );
        break;
      case 'update_system':
        temple = <span>{t('System upgrade schedule')}</span>;
        break;
      default:
        temple = <span>{item.content}</span>;
    }
    return temple;
  };

  const svgPrefixNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'alert':
        temple = <img src={AlertNotification} />;
        break;
      case 'event_object_detection':
        temple = <img src={EventObjectDetectionNotification} />;
        break;
      case 'warning_detection':
        temple = <img src={CameraTampering} />;
        break;
      case 'update_system':
        temple = <img src={UpdateSystemNotification} />;
        break;
      case 'add_device':
        temple = <img src={AddDeviceNotification} />;
        break;
      case 'remove_device':
        temple = <img src={RemoveDeviceNotification} />;
        break;
      case 'disconnected_device':
        temple = <img src={DisconnectedDeviceNotification} />;
        break;
      case 'advertise':
        temple = <img src={AdvertiseNotification} />;
        break;
      default:
    }
    return temple;
  };

  return (
    <Fragment>
      <Modal
        className="modal-detail-notification"
        title={
          <div style={{ display: 'flex' }}>
            <div>{contentNotification(dataDetail ?? '')}</div>
            <div
              style={{
                color: '#797979',
                marginLeft: '8px',
                fontSize: '12px',
                marginTop: '3px',
              }}
            >
              {moment(dataDetail?.updatedAt).format('HH:mm:ss DD-MM-YYYY')}
            </div>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCancelModalDetail}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button key="back" onClick={handleCancelModalDetail}>
            {t('Close')}
          </Button>,
        ]}
      >
        {dataDetail && (
          <img
            src={
              dataDetail.extraInfo &&
              JSON.parse(dataDetail.extraInfo) &&
              (JSON.parse(dataDetail.extraInfo).imageUrl ??
                JSON.parse(dataDetail.extraInfo).url)
            }
            style={{ height: '478px' }}
          />
        )}
      </Modal>

      {currentTab === 'notifications' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '5px',
            gap: 15,
          }}
        >
          <Select
            defaultValue={dataFilterType}
            style={{ width: 180 }}
            onChange={handleChangeSelect}
          >
            <Option value="disconnected_device">
              {t('Disconnected device')}
            </Option>
            <Option value="warning_detection">
              {t('Warning detection')}
            </Option>
            <Option value="alert">{t('Alert')}</Option>
            <Option value="event_object_detection">
              {t('Event object detection')}
            </Option>
            <Option value="update_system">{t('Update System')}</Option>
            <Option value="add_device">Add device</Option>
            <Option value="remove_device">{t('Remove device')}</Option>
            <Option value="advertise">{t('Advertise')}</Option>
          </Select>
          <RangePicker
            key={keyRanger}
            value={[moment(dateRanger?.[0]), moment(dateRanger?.[1])]}
            onChange={handleDateRangerChange}
            disabledDate={(current) => current && current.isAfter(moment(), 'day')}
            allowClear={false}
          />
          <Input.Search
            placeholder={t('Search by name')}
            onChange={(e) => setNotificationInputSearch(e.target.value)}
            allowClear
            style={{ width: 240 }}
            value={notificationInputSearch}
            onSearch={handleSearchNotification}
          />
          <Button
            type="primary"
            onClick={handleDownloadNotification}
            loading={isLoadingDownloadNotification}
            disabled={
              isLoadingDownloadNotification ||
              !dataNotification?.data?.length
            }
            icon={<DownloadOutlined />}
          >
            {t('Download')}
          </Button>
        </div>
      )}
      <Table
        dataSource={
          dataNotification &&
          dataNotification.data &&
          dataNotification.data.map((dataNotif) => ({
            ...dataNotif,
            key: dataNotif?.id,
          }))
        }
        pagination={dataNotification && dataNotification.pagination}
        loading={dataNotification && dataNotification.loading}
        onChange={handleTableChangeNotification}
        columns={[
          {
            title: t('Name'),
            dataIndex: 'name',
            key: 'notif_name',
            render: (text, row) => (
              <div style={{ display: 'flex' }}>
                <span style={{ marginRight: '8px' }}>
                  {svgPrefixNotification(row)}
                </span>
                <span>{contentNotification(row)}</span>
              </div>
            ),
          },
          {
            title: t('Created at'),
            width: 200,
            key: 'notif_date',
            dataIndex: 'updatedAt',
            render: (time) => moment(time).format('HH:mm:ss DD-MM-YYYY'),
          },
        ]}
        expandedRowKeys={expKeys}
        expandable={{
          expandedRowRender: (record) => (
            <div>{extraInfoNotification(record)}</div>
          ),
        }}
        onExpand={(expanded, record) => {
          setExpKeys(expanded ? [record?.id] : []);
          if (expanded) {
            onChangeAlert(record?.extraInfo);
          }
        }}
      />
    </Fragment>
  );
};

export default NotificationsTab;
